export default __webpack_public_path__ + "static/media/sports_tennis.020915ed.svg";